const updateCartItemsWindowArr = (callback) => {
  theme.cart.getCart().then((cart) => {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart: cart,
        },
      })
    );

    window.cartItems = cart.items;

    if (callback) {
      callback();
    }
  });
};

function getCart() {
  return fetch(window.theme.routes.cart)
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      if (!error.description) {
        console.warn(error);
        return;
      }
    });
}

function setHelloRetailCartData(data) {
  var ids = data.items.map(function (item) {
    return item.product_id;
  });

  ADDWISH_PARTNER_NS.api.cart.setCart(
    {
      total: (data.total_price / 100).toString(),
      url: window.theme.routes.cartPage,
      productNumbers: ids.map(String),
      email: window.theme.customer.email ?? '',
    },
    function () {
      console.log('Cart has been tracked');
    }
  );
}

function setCartTracking(event) {
  if (!window.ADDWISH_PARTNER_NS) return;
  if (event?.detail?.cart) {
    setHelloRetailCartData(event.detail.cart);
  } else {
    getCart().then(function (data) {
      setHelloRetailCartData(data);
    });
  }
}

document.addEventListener('cart:updated', setCartTracking);
document.addEventListener('ajaxProduct:added', setCartTracking);
// document.addEventListener('cart:bundle-updated', setCartTracking);
